import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  search: {
    borderRadius: theme.shape.borderRadiusLarge,
    position: "relative",
    [theme.breakpoints.up("md")]: {
      height: 40,
      "& .MuiInputBase-root": {
        borderColor: "rgba(0, 0, 0, 0.23)",
      },
      "& > label": {
        fontSize: theme.typography.h5.fontSize,
        top: -5,
      },
      "& > div": {
        height: 40,
        padding: 0,
        paddingRight: "35px !important",
      },
      "& > div > input": {
        padding: "0 4px !important",
      },
    },
    [theme.breakpoints.down("sm")]: {
      "& *": {
        fontSize: theme.typography.h4.fontSize,
      },
      zIndex: theme.zIndex.drawerContent,
      backgroundColor: "white",
    },
  },
  inputField: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.shape.border,
      border: theme.shape.border,
      borderRadius: 8,
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      border: `1px solid ${theme.palette.inventoryFilterHover} !important`,
    },
    "&:focus .MuiOutlinedInput-notchedOutline": {
      border: `1px solid ${theme.palette.inventoryFilterActive} !important`,
    },
  },
  popper: {
    zIndex: 2000,
  },
}));
